const prefixToPath = (preFixUrl: string) => preFixUrl.substring(1)

export default prefixToPath
